<template>
    <div :class="{ 'balise-card--free': balise?.free && balise?.status !== 'TEST' }"
        class="card h-100 rounded-4 balise-card">
        <div class="card-body h-100 d-flex flex-column pt-3 pb-3 px-3">
            <div class="balise-card-header text-center">
                <div v-if="balise?.free" class="balise-card-badge-free">
                    Non facturable
                </div>
                <VehicleNameDisplay :balise="balise" :showStatuses="true" :linkEnabled="false" />
            </div>

            <div class="balise-card-meta" :title="lastAddress">
                <div class="balise-meta-inline">
                    <div v-if="balise.lastSeen != null" class="balise-meta-time">
                        <LastSeenDisplay :lastSeen="balise.lastSeen" />
                    </div>

                    <font-awesome-icon :icon="['fas', 'location-dot']" class="balise-meta-icon" />

                    <span class="balise-meta-address">
                        {{ lastAddress }}
                    </span>
                </div>
            </div>

            <div class="balise-card-actions">
                <router-link
                    class="balise-card-action-btn"
                    :to="`/balise/${balise.id}`"
                >
                    Fiche
                </router-link>

                <router-link
                    class="balise-card-action-btn"
                    :to="`/alerts/${balise.id}`"
                >
                    Evènements
                </router-link>

                <router-link
                    class="balise-card-action-btn"
                    :to="`/home/${balise.id}`"
                >
                    Carte
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import LastSeenDisplay from '@/components/display/LastSeenDisplay.vue'

export default {
    name: 'BaliseCardDisplay',
    components: {
        VehicleNameDisplay,
        LastSeenDisplay
    },
    props: {
        balise: {
            type: Object,
            required: true
        }
    },
    computed: {
        lastAddress() {
            return this.balise?.lastAddress || this.balise?.address || 'Adresse non disponible'
        }
    }
}
</script>

<style scoped>
.balise-card {
    border: 1px solid #d6dee8;
    box-shadow:
        0 6px 18px rgba(15, 23, 42, 0.10),
        0 2px 4px rgba(15, 23, 42, 0.06);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    background: #fff;
}

.balise-card:hover {
    transform: translateY(-2px);
    box-shadow:
        0 10px 24px rgba(15, 23, 42, 0.14),
        0 4px 8px rgba(15, 23, 42, 0.08);
}

.balise-card-header {
    min-height: 64px;
}

.balise-card--free {
    background: #f8fafc;
    border-color: #d7dee7;
    box-shadow:
        0 3px 10px rgba(15, 23, 42, 0.05),
        0 1px 2px rgba(15, 23, 42, 0.03);
}

.balise-card--free .balise-card-header > :not(.balise-card-badge-free),
.balise-card--free .balise-card-meta {
    filter: grayscale(1) saturate(0);
    opacity: 0.6;
}

.balise-card--free:hover {
    transform: none;
    box-shadow:
        0 3px 10px rgba(15, 23, 42, 0.05),
        0 1px 2px rgba(15, 23, 42, 0.03);
}

.balise-card-badge-free {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.6rem;
    padding: 0.28rem 0.7rem;
    border-radius: 999px;
    background: #e2e8f0;
    color: #475569;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.balise-card-meta {
    text-align: left;
    margin-top: auto;
}

.balise-meta-inline {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    min-width: 0;
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.3;
}

.balise-meta-time {
    flex-shrink: 0;
    white-space: nowrap;
    font-size: 0.72rem;
    color: #94a3b8;
}

.balise-meta-icon {
    flex-shrink: 0;
    font-size: 0.75rem;
    opacity: 0.7;
}

.balise-meta-address {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* ACTIONS */

.balise-card-actions {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.5rem;
    margin-top: 0.9rem;
    padding-top: 0.9rem;
    border-top: 1px solid #e2e8f0;
    opacity: 0.75;
}

.balise-card:hover .balise-card-actions {
    opacity: 1;
}

.balise-card-action-btn {
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    color: #475569;

    min-height: 32px;
    padding: 0.25rem 0.5rem;

    border-radius: 0.7rem;
    font-size: 0.75rem;
    font-weight: 500;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;

    transition: all 0.12s ease;
}

.balise-card-action-btn:hover {
    background: #e2e8f0;
    color: #1e293b;
    transform: translateY(-1px);
    text-decoration: none;
}

@media (max-width: 991.98px) {
    .balise-card-actions {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 575.98px) {
    .balise-card-actions {
        grid-template-columns: 1fr;
    }
}
</style>